<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  components: {},
  created() {
    const userInfo = localStorage.getItem("userInfo");
    if (userInfo) {
      this.$store.commit("user/SET_USER_INFO", JSON.parse(userInfo));
      // 刷新页面时，重新生成路由
      const roles = JSON.parse(userInfo).role;
      if (roles && roles.length) {
        this.$store.dispatch("user/generateRoutes", roles);
      } else {
        this.$router.push("/login");
      }
    } else {
      this.$router.push("/login");
    }
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
body {
  margin: 0px;
}
/* 全局滚动条样式 - WebKit 浏览器 */
::-webkit-scrollbar {
  width: 6px; /* 垂直滚动条宽度 */
  height: 6px; /* 水平滚动条高度 */
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.3);
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.5);
}

/* Firefox 全局滚动条 */
* {
  scrollbar-width: thin; /* thin | auto | none */
  scrollbar-color: rgba(0, 0, 0, 0.3) transparent;
}
</style>
